import { Component, Input } from '@angular/core';

import { SharedConstants, SharedCSSPropertyName } from '@app/eds';

@Component({
  selector: 'app-image[imgName][alt]',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss']
})
export class ImageComponent {
  // exact image name of the file
  @Input() imgName: string = SharedConstants.EMPTY_STRING;

  // imgAlt provides alternate name for the image
  @Input() alt: string = SharedConstants.EMPTY_STRING;

  // imgAlt provides height for the image
  @Input() height: string = SharedConstants.EMPTY_STRING;

  // imgAlt provides width for the image
  @Input() width: string = SharedConstants.EMPTY_STRING;

  /**
   * This method will return custom styles.
   *
   * @returns object.
   */
  getStyles = () => {
    const styleObject: { [key: string]: string } = {};

    this.height && (styleObject[SharedCSSPropertyName.HEIGHT] = this.height);

    this.width && (styleObject[SharedCSSPropertyName.WIDTH] = this.width);

    return styleObject;
  };

  /**
   * Returns the complete path of the assets/images folder with the specified filename
   *
   * @param {string} fileName
   * @returns {string} fullPath of the image
   */
  getImagePath = (fileName: string) => `../../../../assets/images/${fileName}`;
}
